import type { TaxBracket } from '../../types/tax';

export const TAX_BRACKETS_2023_24: TaxBracket[] = [
  {
    min: 1,
    max: 237100,
    rate: 0.18,
    baseAmount: 0
  },
  {
    min: 237101,
    max: 370500,
    rate: 0.26,
    baseAmount: 42678
  },
  {
    min: 370501,
    max: 512800,
    rate: 0.31,
    baseAmount: 77362
  },
  {
    min: 512801,
    max: 673000,
    rate: 0.36,
    baseAmount: 121475
  },
  {
    min: 673001,
    max: 857900,
    rate: 0.39,
    baseAmount: 179147
  },
  {
    min: 857901,
    max: 1817000,
    rate: 0.41,
    baseAmount: 251258
  },
  {
    min: 1817001,
    max: null, // No upper limit
    rate: 0.45,
    baseAmount: 644489
  }
];

export const TAX_YEAR_2023_24 = '2023-24';
export const TAX_YEAR_2023_24_START = new Date('2023-03-01');
export const TAX_YEAR_2023_24_END = new Date('2024-02-29');